import { useFormik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import {connect} from "react-redux";
import { getList as getCriterias } from '../../../actions/criterias'
import { createReview, getTeachers, getCourses } from '../../../actions/reviews'
import { getCathedra } from '../../../actions/management';
import { Pagination } from "../../../assets/Pagination/Pagination";
import Checkbox from '../../../assets/CustomCheckbox/CustomCheckbox'
import styles from '../styles.module.scss'
import { ReviewsContext } from '../../../utils/context';
import GradeComponent from '../../../assets/GradeComponent';
import { SearchInput } from '../../../assets/FindField/FindField';
import { Select } from '../../../assets/NewInputs';
import { FaRegTrashAlt } from 'react-icons/fa';


const initialValues = {
  comment: '',
  anonymous: true,
  scores: {}
}


const AddEditModal = ({
  teacherMode,
  isOpen,
  onRequestClose,
  data,
  staff,
  staffPages,
  criterias,
  courses,
  cathedras,
  getTeachers,
  getCourses,
  getCriterias,
  createReview,
  getListCB,
  getCathedra
}) => {
  
  useEffect(() => {
    if (!isOpen) return;
    setValues({...initialValues, ...data})
  }, [isOpen])
  

  const createReviewHandler = async (values) => {
    const {comment, teacher_id, anonymous} = values
    const scores = Object
      .entries(values.scores)
      .map(([criteria_id, score]) => ({criteria_id, score}))
      .filter(({score}) => !!score)
    const payload = {comment, teacher_id, scores, anonymous}
    const success = await createReview(payload)
    if (!success) return;
    onRequestClose()
    getListCB()
  }
  
  
  const formik = useFormik({
    initialValues,
    onSubmit: createReviewHandler
  })
  
  const contextValue = {formik, staff, staffPages, criterias, courses, cathedras, getCourses, getCriterias, getTeachers, getCathedra}
  const { values, setValues, handleSubmit } = formik
  
  const resetFormHandler = () => {
    if (teacherMode) return;
    // const {teacher_fio, teacher_id, ...restData} = values 
    setValues(initialValues)
  }


  return (
    <ReviewsContext.Provider value={contextValue}>
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="Modal"
      >
        <div className={styles.reviewModal}>
          <h3>Оценить преподавателя. Оставить анонимный отзыв.</h3>
          <div>
            <span className={styles.completed} onClick={resetFormHandler}>
              Выбор преподавателя
            </span>

            <span>→</span>

            <span className={values.teacher_id && styles.completed}>
              Составление отзыва
            </span>
          </div>
          
          <TeacherSelectMode active={!values.teacher_id} />
          
          <ReviewMode active={values.teacher_id} />

          <div>
            {values.teacher_id && <button className='btn' onClick={handleSubmit} >Оценить</button>}
            <button className='btn' onClick={onRequestClose}>Выйти</button>
          </div>
        </div>
      </Modal>
    </ReviewsContext.Provider>
  )
}

const TeacherSelectMode = ({ active }) => {
    
  const {formik, staff, staffPages, courses, cathedras, getCourses, getTeachers, getCathedra} = useContext(ReviewsContext)

  const { values, setValues } = formik


  const [staffPageNumber, setStaffPageNumber] = useState(0)
  const [findString, setFindString] = useState('')
  const [cathId, setCathId] = useState('')
  const [courseId, setCourseId] = useState('')
  const [fullFilters, setFullFilters] = useState(false)

  useEffect(() => {
    getCathedra(0, false, true)
  }, [])

  useEffect(() => {
    getCourses(cathId)
  }, [cathId])

  useEffect(() => {
    getTeachers(staffPageNumber, cathId, courseId, findString)
  }, [staffPageNumber, findString, cathId, courseId])

  const rowClickHandler = (data) => () => {
    setValues({...values, ...data})
  }

  const renderRow = (item) => {
    const {fio, mid} = item
    return (
      <tr onClick={rowClickHandler({teacher_fio: fio, teacher_id: mid})} key={mid}>
        <td>{fio}</td>
      </tr>
    )
  }
  
  const renderOptions = (i) => <option value={i.idcathedra || i.id} key={i.idcathedra || i.id}>{i.cathedra || i.name}</option>

  const clearFiltersHandler = () => {
    setStaffPageNumber(0)
    setFindString('') 
    setCathId('') 
    setCourseId('') 
  }

  return (
    <div style={{display: active ? 'block' : 'none'}} className={styles.teacherSelectModal}>

      <section>
        <SearchInput value={findString} onChange={setFindString} />
        <button>
          <span onClick={clearFiltersHandler}>Сбросить фильтры</span>
          <FaRegTrashAlt size={18}/>
        </button>
      </section>

      <section>
        <div style={{display: fullFilters ? 'flex' : 'none'}}>
          <div>
            <p>Кафедра</p>
            <Select value={cathId} onChange={(e) => setCathId(e.target.value)}>
              <option value=''>Все</option>
              {cathedras?.map(renderOptions)}
            </Select>
          </div>
          <div>
            <p>Дисциплина</p>
            <Select value={courseId} onChange={(e) => setCourseId(e.target.value)}>
              <option value=''>Все</option>
              {courses?.map(renderOptions)}
            </Select>
          </div>
        </div>

        <span onClick={() => setFullFilters(!fullFilters)}>{fullFilters ? 'Свернуть' : 'Расширенный поиск'}</span>
      </section>

      <table>
        <thead>
          <tr>
            <th>ФИО</th>
          </tr>
        </thead>
        <tbody>
          {staff?.map(renderRow)}
        </tbody>
      </table>

      <Pagination
        pageCount={staffPages}
        numberPage={staffPageNumber}
        onPageChange={(page) => setStaffPageNumber(page.selected)}
      />
    </div>
  )
}

const ReviewMode = ({ active }) => {
  
  const { formik, criterias, getCriterias } = useContext(ReviewsContext)
  const {values, handleChange, setValues, setFieldValue} = formik

  useEffect(() => {
    getCriterias({ include_archived: false, category: 'teacher_assessment' })
  }, [])

  useEffect(() => {
    if (!criterias) return;
    const scores = criterias.reduce((acc, item) => ({...acc, [item.id]: 0}), {})
    setValues({...values, scores})
  }, [criterias])
  

  
  const renderCriteria = (item) => {
    return (
      <li key={item.id}>
        <span className={styles.criteriaName}>{item.name}</span>
        <GradeComponent
          value={values.scores[item.id]}
          onChange={(value) => setFieldValue(`scores.${item.id}`, value)}
        />
      </li>
    )
  }

  return (
    <div style={{display: active ? 'block' : 'none'}} className={styles.reviewHandlerModal}>
      
      <section>
        <span>Преподаватель:</span>
        <span>{values.teacher_fio}</span>
      </section>

      <section>
        <p>Критерии оценки качеств преподавателя:</p>
        <ul>
          {criterias?.map(renderCriteria)}
        </ul>
      </section>

      <section>
        <p>Дополните оценку комментарием:</p>
        <textarea
          name='comment'
          value={values.comment}
          onChange={handleChange}
        />
      </section>

      <section>
        <p>Для отправки отзыва нажмите кнопку Оценить.</p>
        <p>Все отзывы являются анонимными.</p>
        <p>При желании можете указать свои данные.</p>
      </section>

      <Checkbox
        label='анонимно'
        checked={values.anonymous}
        onChange={() => setValues({...values, anonymous: !values.anonymous})}
      />

    </div>
  )
}



const mapStateToProps = (state) => ({
  criterias: state.criterias.list,
  staff: state.reviews.teachers.data,
  staffPages: state.reviews.teachers.pageCount,
  courses: state.reviews.courses,
  cathedras: state.management.cathedra,
});


export default connect(mapStateToProps, {getTeachers, getCourses, getCriterias, createReview, getCathedra})(AddEditModal)